import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Lock } from "lucide-react";

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default function GateForm({ onUnlock, submitting, error, disabled }) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");

  const valid =
    !disabled &&
    name.trim().length > 1 &&
    EMAIL_RE.test(email.trim());

  return (
    <div
      data-testid="gate-form"
      className="rounded-2xl border border-[#35D07F]/40 bg-gradient-to-b from-[#12181A] to-[#0F1416] p-6 sm:p-8 relative overflow-hidden"
    >
      <div className="absolute inset-0 pointer-events-none opacity-[0.06]"
           style={{
             backgroundImage:
               "radial-gradient(circle at 20% 10%, #35D07F 0%, transparent 45%)",
           }}
      />
      <div className="relative">
        <div className="inline-flex items-center gap-2 rounded-full border border-[#35D07F]/40 bg-[#35D07F]/10 text-[#35D07F] text-[11px] font-semibold uppercase tracking-[0.2em] px-3 py-1">
          <Lock className="h-3 w-3" strokeWidth={2.5} /> Unlock full report
        </div>
        <h3 className="mt-4 text-2xl sm:text-3xl font-bold tracking-tight text-white">
          5 validated answers &gt; 50 unanswered questions.
        </h3>
        <p className="mt-2 text-sm text-[#A0AAB2] max-w-xl leading-relaxed">
          Drop your name and work email. You'll get every finding, every
          citation, and every conflict flag — free.
        </p>

        <div className="mt-6 grid grid-cols-1 sm:grid-cols-[1fr_1fr_auto] gap-3">
          <Input
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Full name"
            data-testid="gate-name"
            className="bg-[#0B0F10] border-white/10 text-white placeholder:text-white/30 focus-visible:ring-[#35D07F]/50"
          />
          <Input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@company.com"
            data-testid="gate-email"
            className="bg-[#0B0F10] border-white/10 text-white placeholder:text-white/30 focus-visible:ring-[#35D07F]/50"
          />
          <Button
            onClick={() => onUnlock({ name: name.trim(), email: email.trim() })}
            disabled={!valid || submitting}
            data-testid="gate-submit"
            className="rounded-full bg-[#35D07F] hover:bg-[#2CBB70] text-black font-semibold h-11 px-6 disabled:opacity-40"
          >
            {submitting
              ? "Unlocking…"
              : disabled
              ? "Preparing answers…"
              : "Unlock report"}
          </Button>
        </div>

        {error && (
          <div className="mt-3 text-sm text-[#FF5252]" data-testid="gate-error">
            {error}
          </div>
        )}
        <div className="mt-3 text-[11px] text-white/40">
          No spam. Just a heads-up when we add new problem types.
        </div>
      </div>
    </div>
  );
}
